module.exports = {
	"id": "CF",
	"name": "Central African Republic",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.00888,
			"6": 0.09324,
			"7": null,
			"8": 0.03108,
			"9": 0.05328,
			"10": null,
			"11": 0.0222,
			"12": 0.03108,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.12876,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.01332,
			"26": null,
			"27": null,
			"28": 0.39072,
			"29": 0.00888,
			"30": 0.01776,
			"31": 0.0222,
			"32": null,
			"33": 0.0222,
			"34": 0.01776,
			"35": 0.00888,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": 0.05772,
			"43": 0.09768,
			"44": 0.00888,
			"45": 0.05328,
			"46": 0.11988,
			"47": 0.07548,
			"48": 0.80808,
			"49": 0.53724,
			"50": 0.00888,
			"51": 0.38628,
			"52": 0.52836,
			"53": 7.98756,
			"54": 1.4652,
			"55": 0.0222,
			"56": 0.1332,
			"57": null
		},
		"firefox": {
			"2": 0.00888,
			"3": 0.03108,
			"4": 0.05328,
			"5": 0.01332,
			"6": null,
			"7": null,
			"8": 0.00888,
			"9": 0.00888,
			"10": 0.00888,
			"11": 0.03108,
			"12": 0.04884,
			"13": 0.01776,
			"14": 0.04884,
			"15": null,
			"16": 0.01776,
			"17": 0.07548,
			"18": 0.20424,
			"19": 0.03552,
			"20": 0.19536,
			"21": 0.09768,
			"22": 0.06216,
			"23": 0.00888,
			"24": 0.03552,
			"25": 0.02664,
			"26": null,
			"27": 0.00888,
			"28": 0.05772,
			"29": 0.1776,
			"30": 0.56832,
			"31": 0.03108,
			"32": 0.10212,
			"33": 0.18648,
			"34": 0.05328,
			"35": 0.2442,
			"36": 0.09768,
			"37": 0.08436,
			"38": 0.17316,
			"39": 0.03108,
			"40": 0.12432,
			"41": 0.25752,
			"42": 0.10656,
			"43": 0.76812,
			"44": 0.9546,
			"45": 0.72372,
			"46": 0.40404,
			"47": 2.04684,
			"48": 0.84804,
			"49": 6.11388,
			"50": 0.43956,
			"51": 0.01776,
			"52": null,
			"3.5": null,
			"3.6": 0.0222
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.07992,
			"22": null,
			"23": null,
			"24": 0.05328,
			"25": null,
			"26": 0.00888,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.01332,
			"35": 0.00888,
			"36": 0.10656,
			"37": null,
			"38": null,
			"39": 0.05772,
			"40": 0.26196,
			"41": 0.2664,
			"42": 0.09324,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.23976,
			"6": null,
			"7": 0.0222,
			"8": 0.09768,
			"9": 0.02664,
			"10": 0.50616,
			"3.1": null,
			"3.2": null,
			"5.1": 0.07548,
			"6.1": null,
			"7.1": null,
			"9.1": 0.69264
		},
		"ios_saf": {
			"8": 0,
			"10": 1.52439465529,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0410806720441,
			"8.1-8.4": 0.0758948008951,
			"9.0-9.2": 0.036206694005,
			"9.3": 0.552384177769
		},
		"android": {
			"3": 0,
			"4": 0.0855991653747,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0106998956718,
			"4.1": 0.308768417959,
			"4.2-4.3": 0.771921044897,
			"4.4": 1.77006845543,
			"4.4.3-4.4.4": 1.78535402067
		},
		"ie": {
			"6": 0.00888,
			"7": 0.01776,
			"8": 0.54168,
			"9": 0.16428,
			"10": 0.57276,
			"11": 5.03496,
			"5.5": null
		},
		"op_mob": {
			"0": 0.534217269312,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.014839368592
		},
		"edge": {
			"12": 0.18648,
			"13": 0.333,
			"14": 0.10212
		},
		"ie_mob": {
			"10": 0.583356732394,
			"11": 2.37509526761
		},
		"bb": {
			"7": 0.07368325,
			"10": null
		},
		"samsung": {
			"0": 5.032705
		},
		"and_uc": {
			"0": 5.216218
		},
		"op_mini": {
			"0": 7.1974163621
		},
		"and_chr": {
			"0": 31.953892
		},
		"and_ff": {
			"0": 0.450441
		}
	},
	"total": 98.80911625
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CF.json
 ** module id = 491
 ** module chunks = 0
 **/